/* Keep page scrolling separate from horizontal swipes in product cards and lists. */
(() => {
  const Flickity = window.themeVendor?.Flickity || window.Flickity;
  if (!Flickity || window.cherryProductSwipeReady) return;
  window.cherryProductSwipeReady = true;

  const gestures = new WeakMap();
  const pointerDown = Flickity.prototype.pointerDown;
  const hasDragStarted = Flickity.prototype.hasDragStarted;
  const cardSelector = '[data-cherry-collection-slider], [data-product-media-slideshow]';
  const productSelector = '[data-product-media-container], .product-grid-item, .cherry-product-card';

  Flickity.prototype.pointerDown = function (event, pointer) {
    const touch = event.type === 'touchstart' || event.pointerType === 'touch';
    const productSlider = touch && (
      this.element.matches(cardSelector) || this.element.querySelector(productSelector)
    );
    // Reset per gesture, including after cancellation or a change to mouse input.
    gestures.set(this, productSlider ? { axis: null } : null);
    return pointerDown.call(this, event, pointer);
  };

  Flickity.prototype.hasDragStarted = function (movement) {
    const gesture = gestures.get(this);
    if (!gesture) return hasDragStarted.call(this, movement);
    if (!gesture.axis) {
      const horizontal = Math.abs(movement.x);
      const vertical = Math.abs(movement.y);
      if (Math.max(horizontal, vertical) < 12) return false;
      gesture.axis = horizontal > vertical * 1.5 ? 'horizontal' : 'vertical';
    }
    return gesture.axis === 'horizontal';
  };
})();
